// Not required for hover/focus behavior.
// Only add JS if you also want a "tap to toggle" on touch devices.
document.querySelectorAll(".reveal-container").forEach((el) => {
  el.addEventListener("click", (e) => {
    // Avoid hijacking clicks on links/buttons inside
    if (e.target.closest("a, button")) return;
    el.classList.toggle("is-revealed");
  });
});
